import { Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AdminConsoleComponent } from './components/admin-console/admin-console.component';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './guards/auth.guard';
import { HomeComponent } from './components/home/home.component';
import { globalAuthGuard } from './guards/global-auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [globalAuthGuard],
    children: [
      { path: '', component: HomeComponent },
      {
        path: 'admin',
        component: AdminConsoleComponent,
        canActivate: [authGuard],
      },
      { path: 'model', component: DashboardComponent },
    ],
  },
  { path: 'login', component: LoginComponent },
];
